// Sliders
import './sliders';

// Animations
import './animations';

// Bundles and promotions script
import './_bundles-promotions';